import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { membersApi } from '../api/members';
import { api } from '../lib/api';
export function AssignTastingAdmin({
  eventId,
  assigned,
}: {
  eventId: string;
  assigned?: string | null;
}) {
  const { user } = useAuth();
  const qc = useQueryClient();
  const enabled = !!user?.roles.includes('site_admin');
  const members = useQuery({ queryKey: ['members'], queryFn: () => membersApi.list(), enabled });
  const save = useMutation({
    mutationFn: (personId: string) =>
      api.put(`/events/${eventId}/admin`, { personId: personId || null }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['event', eventId] }),
  });
  if (!enabled) return null;
  return (
    <div className="card mb-4">
      <label>
        Delegated tasting administrator
        <select
          className="field mt-2"
          value={assigned ?? ''}
          disabled={save.isPending}
          onChange={(e) => save.mutate(e.target.value)}
        >
          <option value="">No delegate</option>
          {members.data
            ?.filter((m) => m.roles?.includes('tasting_admin'))
            .map((m) => (
              <option key={m.id} value={m.id}>
                {m.firstName} {m.lastName}
              </option>
            ))}
        </select>
      </label>
      <p className="text-xs">
        Grant the Tasting Admin role in member management before assigning a delegate.
      </p>
      {save.error && <p>{save.error.message}</p>}
    </div>
  );
}
